export const lightTheme = {
  body: "#fff",
  text: "#333",
  background: "#f0f0f0",
  hoverBackground: "#737272",
  hoverText: "#fff",
  hoverIconColor: "#f0f0f0",
  linkHover: "#007bff",
  cardBackground: "#fff",
  cardShadow: "rgba(0, 0, 0, 0.1)",
  closeButtonColor: "#000",
  iconColor: "#000",
  tooltipBackground: "#333",
  tooltipText: "#fff",
};

export const darkTheme = {
  body: "#333",
  text: "#f0f0f0",
  background: "#444",
  hoverBackground: "#898989",
  hoverText: "#fff",
  hoverIconColor: "#f0f0f0",
  linkHover: "#007bff",
  cardBackground: "#898989",
  cardShadow: "rgba(0, 0, 0, 0.3)",
  closeButtonColor: "#fff",
  iconColor: "#fff",
  tooltipBackground: "#fff",
  tooltipText: "#333",
};
